<template>
  <v-app>
    <v-main>
      <table-page :headers="headers" :items="items" :rowCount="25" />
    </v-main>
  </v-app>
</template>
<script>
import TablePage from "../../../components/TablePage.vue";
export default {
  components: {
    TablePage,
  },
  data() {
    return {
      headers: [
        {
          text: "Title",
          align: "start",
          value: "title",
        },
        { text: "Abbreviation", value: "abbreviation" },
        { text: "Description", value: "description" },
        { text: "Created Date", value: "createdDate" },
        { text: "Created By", value: "creatorAccount" },
      ],
      items: [
        {
          title: "Position 1",
          abbreviation: "P1",
          description: "position 1 description",
        },
        {
          title: "Position 2",
          abbreviation: "P2",
          description: "position 2 description",
        },
        {
          title: "Position 3",
          abbreviation: "P3",
          description: "position 3 description",
        },
      ],
    };
  },
};
</script>
<style>
.text-start {
  font-size: 14px !important;
}
.td.text-start {
  font-size: 13px !important;
  height: 48px;
}
</style>